
export default {
  props: ["element", "maxWidth"],
  name: "hyperCoreComponent",
  mixins: [],
  data() {
    return { ready: false, _props: {}, mixin: null };
  },
  async mounted() {
    await this.props();
  },
  methods: {
    camelToSnakeCase(str) {
      str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
    },
    async props() {
      let props = {
        element: this.element,
        component: this.element.is.replace("menu", ""),
      };
      if (this.element.is == "coreOptions") {
        props.item = this.$store.getters.item;
      } else if (this.element.is == "userExtra") {
        props.user = this.$store.getters.user;
        props.save = true;
      } else if (this.element.is == "reviews") {
        props.item = this.$store.getters.item;
        props.mode = this.element.mode || "";
      } else if (this.element.is == "register") {
      } else if (this.element.is == "login") {
      } else {
        (this.element.props || []).forEach((p) => {
          let [key, value] = p.split("=");
          props[key] = value;
        });
      }
      if(this.element.scope){
        let scope = this.element.scope.split(';;;');
        scope.forEach((s)=>{
          let [key, value] = s.split(/\=(.*)/s);
          let app = this.$store.getters;
          if(typeof value == 'object'){
            props[key] = value;
          }else{
            let ready = false;
            try{
              props[key] = JSON.parse(value);
              ready = true;
            }catch(e){
            }
            if(!ready){
              try{
                props[key] = eval(value);
              }catch(e){}
            }
          }
        })
      }
      this._props = props;
      this.ready = true;
    },
  },
};
